import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Form from "./pages/Form";
import Dashboard from "./pages/Dashboard";
import Review from "./pages/Review";
import GuidelinesPage from "./pages/Guidelines";

function App() {
  return (
    <Router>
      {/* <nav className="space-x-4 p-4 bg-gray-200">
        <Link to="/">Home</Link>
        <Link to="/form">Form</Link>
        <Link to="/dashboard">Dashboard</Link>
      </nav> */}
      <div className="p-4">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/form" element={<Form />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/review/:nickname" element={<Review />} />
          <Route path="/guidelines" element={<GuidelinesPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
